import { ParameterError } from '../../types/errors';
export const AI_AGENT_DOCUMENT_MAX_CONTENT_BYTES = 20 * 1024;
export const AI_AGENT_DOCUMENT_MAX_NAME_LENGTH = 255;
export const AI_AGENT_DOCUMENT_ORG_QUOTA_BYTES = 5 * 1024 * 1024;
export const getAiAgentDocumentFileExtension = (mimeType) => (mimeType === 'text/plain' ? '.txt' : '.md');
export const getAiAgentDocumentMimeType = (fileName) => fileName.toLowerCase().endsWith('.txt') ? 'text/plain' : 'text/markdown';
/** Trims the name and rejects an empty or over-long one. */
export const normalizeAiAgentDocumentName = (name) => {
    const trimmed = name.trim();
    if (trimmed.length === 0) {
        throw new ParameterError('Document name cannot be empty');
    }
    if (trimmed.length > AI_AGENT_DOCUMENT_MAX_NAME_LENGTH) {
        throw new ParameterError(`Document name cannot exceed ${AI_AGENT_DOCUMENT_MAX_NAME_LENGTH} characters`);
    }
    return trimmed;
};
//# sourceMappingURL=documentTypes.js.map